/*
  List Position Controller

  Handles setting and updating the list position indicator and emitting an event when it is set

  EMITTED EVENTS
    listChange (parent of this controller's element) Emitted when setAllPositions is invoked
      detail: { el: the root element of this controller instance }
*/

import { createCustomEvent } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['display', 'field'];

  connect() {
    this.parent = this.element.parentElement;
    this.setPosition();
    App.Helpers.listenToCustomEvent(this.parent, 'listChange', this.setPosition.bind(this));
  }

  setPosition() {
    if (this.isRendering) {
      this.display = this.fieldVal = this.allRenderingItems.reduce((pos, item, index) => item === this.element ? index : pos, null) + 1;
    }
  }

  setAllPositions() {
    this.parent.dispatchEvent(createCustomEvent('listChange', this.element));
  }

  //
  // GETTERS AND SETTERS
  //

  get parent() {
    return this._parent;
  }

  set parent(el) {
    this._parent = el;
  }

  get allRenderingItems() {
    return [...this.parent.querySelectorAll('[data-controller*="list-position"]')].filter(el => el.style.display !== 'none');
  }

  get isRendering() {
    return this.element.style.display !== 'none';
  }

  set display(val) {
    this.hasDisplayTarget && (this.displayTarget.innerText = val);
  }

  set fieldVal(val) {
    this.hasFieldTarget && (this.fieldTarget.value = val);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/list-position-controller.js